const e = "ids-menu-item-v5150", t = "ids-menu-item--text-v5150", n = "ids-menu-item--selected-v5150", i = "ids-menu-item--multi-select-v5150", m = "ids-menu-item--button-v5150", s = "ids-menu-item--text-append-v5150", d = "ids-menu-item--text-prepend-v5150", c = "ids-menu-item--heading-v5150", u = "ids-menu-item--contents-v5150", o = "ids-menu-item--append-v5150", v = "ids-menu-item--divider-v5150", l = "ids-menu-item--no-wrap-v5150", a = "ids-menu-item--list-item-v5150", p = "ids-menu-item--checkbox-mark-v5150", x = {
  menuItem: e,
  text: t,
  "menu--nav": "ids-menu-item--menu--nav-v5150",
  selected: n,
  multiSelect: i,
  "menu--inline": "ids-menu-item--menu--inline-v5150",
  "menu--inline-equal-width": "ids-menu-item--menu--inline-equal-width-v5150",
  button: m,
  textAppend: s,
  textPrepend: d,
  heading: c,
  "menu--stack": "ids-menu-item--menu--stack-v5150",
  contents: u,
  append: o,
  "ids-checkbox-label": "ids-checkbox-label-v5150",
  divider: v,
  noWrap: l,
  listItem: a,
  checkboxMark: p
};
export {
  x as s
};
